import styled from 'styled-components';

const BaseStyled = `
    display: flex;
    background-color: #2b292b;
    align-items: center;
    justify-content: center;
    font-family: 'zx_spectrum7_boldregular', sans;
    font-size: 30px;
    text-align: center;

    position: relative;

    color: #ffffff;

    cursor: pointer;
    text-transform: uppercase;

    border: 5px solid #ffffff;
    background-color: #d82a52;

    box-shadow: 0 5px 0 #cccccc;

    &.border-image:after {
        content: '';
        width: 100%,
        height: 100%;
        border-style: solid;
        border-image: url(
            ./static/images/border.png
        ) 46 37 40 43 fill / 1 / 0 repeat;
        border-width: 1em;
        position: absolute;
        top: -0.5em;
        bottom: -0.5em;
        left: -0.5em;
        right: -0.5em;
    }

    &:active {
        transform: translateY(5%);
        box-shadow: 0 2px 0 #cccccc;
    }

    &:hover {
        color: #ffffff;
        text-decoration: none;
    }

    &:disabled, &.disabled {
        cursor: not-allowed;
    }

    &:active, &:focus, &:visited {
    }
`; 

export const NavLink = styled.button `
    ${BaseStyled}
`;

export const Button = styled.button `
    ${BaseStyled}
`;